import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  withIcon = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#5BBFB5] text-white hover:bg-[#4DAF9F] focus:ring-[#5BBFB5]',
    secondary: 'bg-[#1B2A3D] text-white hover:bg-[#243548] focus:ring-[#1B2A3D]',
    outline: 'bg-transparent border border-[#E8E8E6] text-[#3A3A3A] hover:border-[#5BBFB5] hover:text-[#5BBFB5]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-347">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-348" />}
    </button>;
}